import { useState } from 'react';

export default (name, initialValue) => {
	const [value, setValue] = useState(initialValue);

	return {
		value,
		setValue,
		name,
		reset: () => setValue(''),
		bind: {
			name,
			value,
			onChange: (event) => {
				setValue(event.target.value);
				return {
					name: event.target.name,
					value: event.target.value,
				};
			},
		},
	};
};